import { render, staticRenderFns } from "./LessonsOnStandby.vue?vue&type=template&id=28ab8fa1&scoped=true&"
import script from "./LessonsOnStandby.vue?vue&type=script&lang=js&"
export * from "./LessonsOnStandby.vue?vue&type=script&lang=js&"
import style0 from "./LessonsOnStandby.vue?vue&type=style&index=0&id=28ab8fa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab8fa1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardTitle,VChip,VDivider})
